import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

export default {
    name : 'swiper--files',

    init()
    {
        const items = document.querySelectorAll('.swiper--files');
        if (items.length) {
            this.run();
        }
    },
    run ()
    {
        const collections = document.querySelectorAll('.swiper--files');

        if (!collections) {
            return false;
        }
        const sliderIds = [];
        collections.forEach( (element) => sliderIds.push(element.id));

        const sliders = [];

        if (sliderIds.length) {
            for (let i=0; i<sliderIds.length;i++) {
                sliders[i] = new Swiper('#'+sliderIds[i] , {
                        spaceBetween: 30,
                        slidesPerView: 1,
                        pagination : {
                            el:  '.'+sliderIds[i]+".swiper-pagination",
                            type: 'progressbar'
                        },
                        navigation: {
                            nextEl: '.'+sliderIds[i]+ ".swiper-button-next",
                            prevEl: '.'+sliderIds[i] + ".swiper-button-prev",
                        },
                        breakpoints: {
                            768: {
                              slidesPerView: 3
                            },
                            1280: {
                              slidesPerView: 5
                            }
                        }
                    }
                );
            }
        }
    } // run

} // export